import React from 'react';

/**
 * Shows `fallback` instead of its children when they fail to render, so the
 * error doesn't take down anything outside it. Errors are reported to Sentry
 * by `onCaughtError` in gatsby-browser.
 */
export default class ErrorBoundary extends React.Component<
    { children: React.ReactNode; fallback?: React.ReactNode },
    { hasError: boolean }
> {
    state = { hasError: false };

    static getDerivedStateFromError(): { hasError: boolean } {
        return { hasError: true };
    }

    render(): React.ReactNode {
        if (this.state.hasError) {
            return this.props.fallback ?? null;
        }
        return this.props.children;
    }
}
